import { render, staticRenderFns } from "./Quotes.vue?vue&type=template&id=f1095eca&"
import script from "./Quotes.vue?vue&type=script&lang=ts&"
export * from "./Quotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports